export default __webpack_public_path__ + "static/media/ssl.e1ccb414.svg";